// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class DeleteFolderReducer extends Reducer
{
	public static reducerName: string = "DeleteFolder";
	public static call(_folderId: number, _preserveElements: boolean) {
		this.getReducer().call(_folderId, _preserveElements);
	}

	public call(_folderId: number, _preserveElements: boolean) {
		const serializer = this.client.getSerializer();
		let _folderIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_folderIdType, _folderId);
		let _preserveElementsType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		serializer.write(_preserveElementsType, _preserveElements);
		this.client.call("DeleteFolder", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let folderIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let folderIdValue = AlgebraicValue.deserialize(folderIdType, adapter.next())
		let folderId = folderIdValue.asNumber();
		let preserveElementsType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		let preserveElementsValue = AlgebraicValue.deserialize(preserveElementsType, adapter.next())
		let preserveElements = preserveElementsValue.asBoolean();
		return [folderId, preserveElements];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _folderId: number, _preserveElements: boolean) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _folderId: number, _preserveElements: boolean) => void)
	{
		this.client.on("reducer:DeleteFolder", callback);
	}
}


export default DeleteFolderReducer
